import { generateQueryParams } from '@xmatters/redux/services/util';

export const LOAD_USER_DEVICES = `LOAD_USER_DEVICES`;
export const LOAD_USER_DEVICES_START = `${LOAD_USER_DEVICES}_START`;
export const LOAD_USER_DEVICES_SUCCESS = `${LOAD_USER_DEVICES}_SUCCESS`;
export const LOAD_USER_DEVICES_FAIL = `${LOAD_USER_DEVICES}_FAIL`;

export const LOAD_DEVICE_NAMES = 'LOAD_DEVICE_NAMES';
export const LOAD_DEVICE_NAMES_START = `${LOAD_DEVICE_NAMES}_START`;
export const LOAD_DEVICE_NAMES_SUCCESS = `${LOAD_DEVICE_NAMES}_SUCCESS`;
export const LOAD_DEVICE_NAMES_FAIL = `${LOAD_DEVICE_NAMES}_FAIL`;

export const LOAD_DEVICE_TYPES = 'LOAD_DEVICE_TYPES';
export const LOAD_DEVICE_TYPES_START = `${LOAD_DEVICE_TYPES}_START`;
export const LOAD_DEVICE_TYPES_SUCCESS = `${LOAD_DEVICE_TYPES}_SUCCESS`;
export const LOAD_DEVICE_TYPES_FAIL = `${LOAD_DEVICE_TYPES}_FAIL`;

export const ADD_DEVICE_NAME = 'ADD_DEVICE_NAME';
export const ADD_DEVICE_NAME_START = `${ADD_DEVICE_NAME}_START`;
export const ADD_DEVICE_NAME_SUCCESS = `${ADD_DEVICE_NAME}_SUCCESS`;
export const ADD_DEVICE_NAME_FAIL = `${ADD_DEVICE_NAME}_FAIL`;
export const ADD_DEVICE_NAME_RESET = `${ADD_DEVICE_NAME}_RESET`;

export const ADD_USER_DEVICE = 'ADD_USER_DEVICE';
export const ADD_USER_DEVICE_START = `${ADD_USER_DEVICE}_START`;
export const ADD_USER_DEVICE_SUCCESS = `${ADD_USER_DEVICE}_SUCCESS`;
export const ADD_USER_DEVICE_FAIL = `${ADD_USER_DEVICE}_FAIL`;

const defaultParams = {
  embed: 'timeframes',
  phoneNumberFormat: 'COUNTRY_CODE',
};

export function loadUserDevices(userUuid, params = defaultParams) {
  return {
    type: LOAD_USER_DEVICES,
    userUuid,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${userUuid}/devices?${generateQueryParams(
        params,
      )}`,
      method: 'get',
    },
  };
}

export const loadDeviceNames = (params = {}) => ({
  type: LOAD_DEVICE_NAMES,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/device-names`,
    params: { ...params, limit: 1000 },
    method: 'getall',
  },
});

export const loadDeviceTypes = () => ({
  type: LOAD_DEVICE_TYPES,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/global/device-types`,
    params: { limit: 100 },
    method: 'getall',
  },
});

export const addDeviceName = (params = {}) => ({
  type: ADD_DEVICE_NAME,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/device-names`,
    method: 'post',
    params,
  },
});

export const resetDeviceNames = () => ({
  type: ADD_DEVICE_NAME_RESET,
});

export const addUserDevice = (userUuid, device) => ({
  type: ADD_USER_DEVICE,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/devices`,
    method: 'post',
    params: {
      owner: { id: userUuid },
      ...device,
    },
  },
});
